import HeaderView from './containers/HeaderViewContainer';

export default HeaderView;
